// TODO: This should be split into several, smaller components
import { Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { setHomePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';
import { IButton } from 'src/common/interfaces/IButton';
import { AppState } from 'src/common/redux/configure-store';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import TrainingModeWatermark from 'src/common/training-mode/training-mode-watermark';
import { RifmOptions } from 'src/keypad/keypad-operation';
import { CartRewardData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { codeContainerStyles } from 'src/common/components/code-container/components/code-container-styles';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import Keypad from 'src/keypad/components/keypad';
import { stylesRewardsAmounts } from './redeem-rewards-amount-styles';
import { RedeemRewardsButtons, ProcessRedeemButtonsProps } from './redeem-rewards-buttons';
import { RewardApprovalBody } from 'src/common/helpers/transaction-helper';
import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { EmeraldErrorModal } from 'src/common/api/emerald-error';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';

export const showRedeemRewardsAmount = (
  props: ProcessRewardsProps & ProcessRedeemButtonsProps,
): void => {
  setHomePage(<ProcessRedeemRewards {...props} />);
};

type Props = ProcessRedeemRewardsStates & ProcessRewardsProps & ProcessRedeemButtonsProps;

const ProcessRedeemRewardsPage: React.FC<Props> = ({
  notNowHandler,
  backHandler,
  trainingModeActive,
  reward,
  inputCallback,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const classes = codeContainerStyles();
  const trainingModeClasses = trainingModeStyles();
  const classesRewardsAmounts = stylesRewardsAmounts();
  const rewardAmount = reward?.redeemableLoyaltyProgram?.amount || 0;
  const isLeftHanded = CashierPreferencesHelper.isLeftHanded();

  const [keyboardId, setKeyboardId] = useState('');

  const handleInputPayment = async (input: string): Promise<void> => {
    setKeyboardId('q');
    const amount = parseFloat(input);
    if (amount > rewardAmount || amount === 0) {
      if (amount === 0) {
        popupMessage(
          new EmeraldErrorModal({
            message: 'TenderExchangeInvalidAmount',
            type: EmeraldDialogTypes.Error,
            subMessage: `MSVRedeemZeroError`,
            subMessageArgs: { arg: convertCurrency(rewardAmount) },
            acceptButtonLabel: 'close',
          }),
        );
      } else {
        popupMessage(
          new EmeraldErrorModal({
            message: 'TenderExchangeInvalidAmount',
            type: EmeraldDialogTypes.Error,
            subMessage: 'MSVRedeemError',
            subMessageArgs: { arg: convertCurrency(rewardAmount) },
            acceptButtonLabel: 'close',
          }),
        );
      }
    } else {
      const span = createSpan(`Redeem Rewards Amount`);
      const rewardRequest: RewardApprovalBody = {
        approved: true,
        promotionId: reward?.promotionId ?? '',
        programId: reward?.redeemableLoyaltyProgram?.programId ?? '',
        amount: parseFloat(input),
      };
      await withSpinner(async () => {
        inputCallback(rewardRequest);
      });

      endSpan(span);
    }
  };

  const submitButton: IButton = {
    label: 'APPLY',
    onClick: handleInputPayment,
    testId: 'submit-keypad-button',
  };

  return (
    <Grid
      container
      direction={isLeftHanded ? 'row-reverse' : 'row'}
      justifyContent='center'
      className={`fullHeight flexFull ${
        trainingModeActive ? trainingModeClasses.trainingModeBackground : classes.background
      }`}
    >
      {trainingModeActive && (
        <TrainingModeWatermark
          dataTestId='process-tender-training-mode-watermark'
          supplementalStyles={trainingModeClasses.centerRedeemAmountTrainingTradeMark}
        />
      )}

      <Grid item xs={9}>
        <Grid
          container
          className={`fullHeight flexFull`}
          direction='row'
          justifyContent='center'
          alignItems='flex-end'
        >
          <Grid item xs={7}>
            <Typography align='center' variant={'h2'}>
              {t('RedeemRewards')}
            </Typography>

            <Typography className={classesRewardsAmounts.redeemRewardBar} />

            <Typography
              align='center'
              variant={'h4'}
              className={`${classesRewardsAmounts.redeemMarginBottom}`}
              data-testid='redeem-rewards-amount'
            >{`${convertCurrency(rewardAmount)}`}</Typography>

            <Typography variant={'body2'} className={classesRewardsAmounts.redeemInfoText}>
              {t('RewardsAmount')}
            </Typography>

            <Typography
              variant={'body1'}
              className={`${classesRewardsAmounts.redeemInfoText} ${classesRewardsAmounts.redeemMarginTop}`}
              align='center'
            >
              {t('RewardsAmount_SubMessage_Amount')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <RedeemRewardsButtons {...{ notNowHandler, backHandler }} />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={3}>
        <Grid
          container
          className={`fullHeight flexFull ${classesRewardsAmounts.redeemKeypadPadding}`}
          direction='row'
          justifyContent='flex-end'
          alignItems='flex-end'
        >
          <Grid>
            <Keypad
              visible={true}
              keyboardId={keyboardId}
              noInputField={false}
              keypadTestIdPrefix={'redeem-rewards-amount-'}
              // topLabelText={t(getKeypadHeaderText())}
              submitButton={submitButton}
              disableDecimalInput={true}
              disableManualWeight={true}
              disableQuantity={true}
              replaceDecimalInput={true}
              formatter={RifmOptions.price}
              inputFieldText={t('Amount')}
              inputInstructionsLabelText={t('POSKeyPadInstructionLabelText')}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

interface ProcessRewardsProps {
  reward?: CartRewardData;
  inputCallback: (rewardRequest: RewardApprovalBody) => void;
}
interface ProcessRedeemRewardsStates {
  isKeypadVisible: boolean;
  trainingModeActive: boolean;
}
const mapStateToProps = (state: AppState): ProcessRedeemRewardsStates => ({
  isKeypadVisible: state.middleArea.salesKeypad,
  trainingModeActive: state.posMode.trainingMode,
});

const ProcessRedeemRewards = connect(mapStateToProps)(ProcessRedeemRewardsPage);
export default ProcessRedeemRewards;
